"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceVoucherType = exports.balanceCategoryWithDistribution = exports.balanceCategory = exports.balance = void 0;
const __1 = __importDefault(require(".."));
const balance = (caseVouchers, postProcessing) => {
    var _a, _b, _c;
    return __1.default.vouchers
        .postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: ((_a = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _a === void 0 ? void 0 : _a.includeIrrecoverableVouchers) || false,
        includeDeletedVouchers: ((_b = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _b === void 0 ? void 0 : _b.includeDeletedVouchers) || false,
        includeExpiredVouchers: ((_c = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _c === void 0 ? void 0 : _c.includeExpiredVouchers) || false,
    })
        .reduce((acc, voucher) => voucher.amount + acc, 0);
};
exports.balance = balance;
const balanceCategory = (caseVouchers, category, postProcessing) => {
    var _a, _b, _c;
    return __1.default.vouchers
        .postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: ((_a = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _a === void 0 ? void 0 : _a.includeIrrecoverableVouchers) || false,
        includeDeletedVouchers: ((_b = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _b === void 0 ? void 0 : _b.includeDeletedVouchers) || false,
        includeExpiredVouchers: ((_c = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _c === void 0 ? void 0 : _c.includeExpiredVouchers) || false,
    })
        .reduce((acc, voucher) => (voucher.category === category ? voucher.amount : 0) + acc, 0);
};
exports.balanceCategory = balanceCategory;
const balanceCategoryWithDistribution = (caseVouchers, category, postProcessing) => {
    var _a, _b, _c;
    return __1.default.vouchers.postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: ((_a = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _a === void 0 ? void 0 : _a.includeIrrecoverableVouchers) || false,
        includeDeletedVouchers: ((_b = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _b === void 0 ? void 0 : _b.includeDeletedVouchers) || false,
        includeExpiredVouchers: ((_c = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _c === void 0 ? void 0 : _c.includeExpiredVouchers) || false,
    }).reduce((acc, caseVouchers) => (caseVouchers.category === category
        ? caseVouchers.amount - caseVouchers.distributionAmount
        : 0) + acc, 0);
};
exports.balanceCategoryWithDistribution = balanceCategoryWithDistribution;
const balanceVoucherType = (caseVouchers, postProcessing, ...typeIds) => {
    var _a, _b, _c;
    const lookup = typeIds.reduce((acc, id) => (Object.assign(Object.assign({}, acc), { [id]: true })), {});
    return __1.default.vouchers
        .postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: ((_a = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _a === void 0 ? void 0 : _a.includeIrrecoverableVouchers) || false,
        includeDeletedVouchers: ((_b = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _b === void 0 ? void 0 : _b.includeDeletedVouchers) || false,
        includeExpiredVouchers: ((_c = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _c === void 0 ? void 0 : _c.includeExpiredVouchers) || false,
    })
        .reduce((acc, caseVouchers) => (lookup[caseVouchers.voucherTypeId] ? caseVouchers.amount : 0) + acc, 0);
};
exports.balanceVoucherType = balanceVoucherType;
//# sourceMappingURL=index.js.map